import { AxiosError } from "axios";

import { djangoAxiosInstance } from "../../api";
import { endpoints } from "../constants/endpoints";

export const getPricingDetailsList = async () => {
  try {
    const { data } = await djangoAxiosInstance.get(
      endpoints.GET_PRICING_DETAILS_LIST,
    );

    return data;
  } catch {
    throw new AxiosError("Failed to get Pricing Details");
  }
};
